import DOMPurify from 'dompurify';
import React from 'react';
import {Body, designSystemToken, Icon} from '@lightricks/react-design-system';
import styles from './BriefItemHtml.module.scss';

DOMPurify.addHook('afterSanitizeAttributes', (node: Element) => {
  if (node.tagName === 'A') {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

function sanitize(html: string): string {
  return DOMPurify.sanitize(html);
}

interface BriefItemHtmlProps {
  contentHtml: string | null;
  highlighted?: string;
  testID?: string;
}

function BriefItemHtml({
  contentHtml,
  highlighted,
  testID = 'brief-item-html',
}: BriefItemHtmlProps) {
  if (!contentHtml && !highlighted) {
    return null;
  }

  return (
    <div data-testid={testID}>
      {contentHtml ? (
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{__html: sanitize(contentHtml)}}
        />
      ) : null}
      {highlighted ? (
        <div
          className={styles.highlighted}
          data-testid={`${testID}-highlighted`}
        >
          <Icon
            size="medium"
            appearance="neutral"
            name="Actions-Alert-Line"
            color={designSystemToken('semantic.fg.warning')}
          />
          <Body size="md">{highlighted}</Body>
        </div>
      ) : null}
    </div>
  );
}

export default BriefItemHtml;
